import React, { createContext, useContext, useState, useCallback } from "react"

const AuthContext = createContext(null)

// Decode a JWT payload without a library (just base64url of the middle part).
function readToken(token) {
  if (!token) return null
  try {
    const payload = JSON.parse(atob(token.split(".")[1]))
    if (payload.exp && payload.exp * 1000 < Date.now()) return null // expired
    return payload
  } catch {
    return null
  }
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => {
    const t = localStorage.getItem("ifelt_token")
    return readToken(t) ? t : null
  })
  const [email, setEmail] = useState(() => localStorage.getItem("ifelt_email") || null)

  const login = useCallback((jwt, userEmail) => {
    localStorage.setItem("ifelt_token", jwt)
    if (userEmail) localStorage.setItem("ifelt_email", userEmail)
    setToken(jwt)
    setEmail(userEmail || null)
  }, [])

  const logout = useCallback(() => {
    localStorage.removeItem("ifelt_token")
    localStorage.removeItem("ifelt_email")
    setToken(null)
    setEmail(null)
  }, [])

  const value = { token, email, isAuthenticated: !!token, login, logout }
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error("useAuth must be used within an AuthProvider")
  return ctx
}
